import React from 'react'

const NotFoundPage = () =>{
    return(
        <div style={{minHeight: '100vh', paddingTop: 70}}>
            <h1>Not Found!!!</h1>
        </div>
    )
}

export default NotFoundPage

